import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title?: string;
  description?: string;
  imageUrl?: string;
  canonicalUrl?: string;
  type?: 'website' | 'article';
  keywords?: string;
  author?: string;
}

export const SEOHead = ({ 
  title = "دراية - Diraya.AI | الدليل الشامل لأدوات الذكاء الاصطناعي",
  description = "دراية - الدليل الشامل لأدوات الذكاء الاصطناعي باللغة العربية",
  imageUrl = "/og-image.png",
  canonicalUrl = "https://diraya.ai",
  type = "website",
  keywords = "الذكاء الاصطناعي, أدوات الذكاء الاصطناعي, دليل الذكاء الاصطناعي, artificial intelligence, AI tools",
  author = "Diraya.AI"
}: SEOHeadProps) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      <meta charSet="UTF-8" />
      <meta name="language" content="Arabic" />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="دراية - Diraya.AI" />
      <meta property="og:locale" content="ar_SA" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Enhanced Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@BoDresha" />
      <meta name="twitter:creator" content="@BoDresha" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:domain" content="diraya.ai" />

      {/* Mobile App Meta Tags */}
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="دراية" />
      <meta name="theme-color" content="#006D77" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="application-name" content="دراية" />
      <meta name="format-detection" content="telephone=no" />

      {/* PWA Links */}
      <link rel="manifest" href="/manifest.json" />
      <link rel="apple-touch-icon" href="/icon-192x192.png" />

      {/* Sitemaps */}
      <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      <link rel="sitemap" type="application/xml" href="/api/sitemap" />

      {/* Preconnect to Important Origins */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
    </Helmet>
  );
};